import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/new_login'
import Register from '@/components/home/new_register'
// import Layout from '@/components/Layout'
import Layout from '@/components/managebot/Layout'
import HomePage from '@/components/home/HomePage'
import authen_callbackoneid from '@/components/authenCallbackOneid'
import Download from '@/components/home/download'
import DownloadUat from '@/components/home/download-uat'
import Policy from '@/components/home/Policy'
import Aboutus from '@/components/home/AboutUs'
import api from '@/components/home/API'
import apihomepage from '@/components/home/ApiHomepage'
import contactus from '@/components/home/Footer'
import notfound from '@/components/notfound'
// import startchatapi from '@/components/home/api/startchatapi'
import Layoutmo from '@/components/Layoutmo'
// import ChatLayoutmobile from '@/components/mobile/ChatLayoutmobile'
// devprofile
// import devprofile from '@/components/Devprofile'
import devprofile from '@/components/managebot/dialogNavbar/Devprofile'
// import createbot from '@/components/createbot'
import createbot from '@/components/managebot/createbot'
// import editbot from '@/components/editbot'
import editbot from '@/components/managebot/detailbot'
// import firstbot from '@/components/firstbot'
import firstbot from '@/components/managebot/firstpage'
// import msgreply from '@/components/msgreply'
import msgreply from '@/components/managebot/msgreply/msg_reply'

// import bothomepage from '@/components/bothomepage'
import bothomepage from '@/components/managebot/listbot'
// bot mobile
import detailbot from '@/components/mobile/DetailBot'
import homepagemo from '@/components/mobile/HomePageBotMobile'
import devprofilemo from '@/components/mobile/ProfileDevelopMobile'
import createbotmo from '@/components/mobile/CreateBotMobile'
import msgreplymo from '@/components/mobile/MsgReplyBotMobile'
import managebotmo from '@/components/mobile/ManageBotMo'
import listbotmo from '@/components/mobile/ListbotMo'
// apibot
import homepageapibot from '@/components/home/api/startchatapi'
import authorization from '@/components/home/api/authorization'
// api about bot information
import apigetlistroom from '@/components/home/api/api_getlistroom'
import apisearchfriend from '@/components/home/api/api_searchfriend'
// apibot replymessage
import apireplymessageadd from '@/components/home/api/replymsg_add'
import apireplymessageedit from '@/components/home/api/replymsg_edit'
import apireplymessageremove from '@/components/home/api/replymsg_remove'
import apireplymessageshow from '@/components/home/api/replymsg_show'
// apibot managebot
import apimanagebotadd from '@/components/home/api/createbot'
import apimanagebotshow from '@/components/home/api/managebot_show'
import apimanagebotremove from '@/components/home/api/managebot_remove'
import apimanageboteditname from '@/components/home/api/managebot_editname'
import apimanageboteditstatus from '@/components/home/api/managebot_editstatus'
import apimanageboteditpicturebot from '@/components/home/api/managebot_editpicture'
import apimanageboteditwebhook from '@/components/home/api/managebot_editwebhook'
import apimanageboteditwelcomemessage from '@/components/home/api/managebot_editmsgdefault'
// apibot reply
import apiwebhookdisabledwebview from '@/components/home/api/reply/webhook_disabled_webview'
import apiwebhookswitchkeyboard from '@/components/home/api/reply/webhook_switch_keyboard'
import apiwebhookreplyfile from '@/components/home/api/reply/webhook_replyfile'
import apiwebhookreplymsg from '@/components/home/api/reply/webhook_replymsg'
import messageSendBroadcast from '@/components/home/api/messagesend_broadcast'
import templateSendBroadcast from '@/components/home/api/webhook/templategroupwebhook'
import apiwebhookrecieve from '@/components/home/api/reply/webhook_recieve'
import apiwebhookreplyloc from '@/components/home/api/reply/webhook_replylocation'
import apiwebhookreplysticker from '@/components/home/api/reply/webhook_replysticker'
import apiwebhookreplywebview from '@/components/home/api/reply/webhook_replywebview'
import apiwebhookreplyapprove from '@/components/home/api/reply/webhook_replyapprove'
// apibot aboutwebhook
import apiaboutwebhook from '@/components/home/api/webhook/aboutwebhook'
import apirecievemsgwebhook from '@/components/home/api/webhook/recievemsgwebhook'
import apirecievefilewebhook from '@/components/home/api/webhook/recievefilewebhook'
import apirecievelocationwebhook from '@/components/home/api/webhook/recievelocationwebhook'
import apirecievestickerwebhook from '@/components/home/api/webhook/recievestickerwebhook'
import apirecieveqrcodebottommenuwebhook from '@/components/home/api/webhook/recieveqrcodebottommenu'
import apinotiaddbot from '@/components/home/api/webhook/notiaddbotwebhook'
import apinotiaddgroup from '@/components/home/api/webhook/notiaddgroupwebhook'
import apinotileavegroup from '@/components/home/api/webhook/notileavegroupwebhook'
// apibot template
import apiabouttemplate from '@/components/home/api/template/about_template'
import apitemplatemessage from '@/components/home/api/template/template_message'
import apitemplatelink from '@/components/home/api/template/template_link'
import apitemplatewebview from '@/components/home/api/template/template_webview'
import apitemplatefile from '@/components/home/api/template/template_file'
// apibot quick reply
import apiaboutquickreply from '@/components/home/api/quickreply/aboutQuickReply'
import apiquickreplymessage from '@/components/home/api/quickreply/quickreply_message'
import apiquickreplylink from '@/components/home/api/quickreply/quickreply_link'
import apiquickreplywebview from '@/components/home/api/quickreply/quickreply_webview'
import apiquickreplydatepicker from '@/components/home/api/quickreply/quickreply_datepicker'
import apiquickreplydatetimepicker from '@/components/home/api/quickreply/quickreply_datetimepicker'
import apiquickreplymap from '@/components/home/api/quickreply/quickreply_map'
import apiquickreplyimage from '@/components/home/api/quickreply/quickreply_image'
import apiquickreplyfile from '@/components/home/api/quickreply/quickreply_file'
import apiquickreplyocr from '@/components/home/api/quickreply/quickreply_ocr'
// docsbottommeunu
import docsbottommenuabout from '@/components/home/api/docsbottommenu/about'
import docsbottommenugetprofile from '@/components/home/api/docsbottommenu/getprofile'
// sticker
import stickerlayout from '@/components/sticker/stickerhomepage'
import stickerhomepage from '@/components/sticker/homepage'
import stickerwonder from '@/components/sticker/sticker_wonder'
import stickerwonderHNY from '@/components/sticker/sticker_wonderHNY'
// test
import test from '@/components/test'
import test2 from '@/components/test2'
import test3 from '@/components/test3'
import test4 from '@/components/test4'
import test5 from '@/components/test5'
import test6 from '@/components/test6'
import test7 from '@/components/test7'
import testcanvas from '@/components/testcanvas'
import testInAppWebview from '@/components/test_inappwebview'
import codeInAppWebview from '@/components/code_inappwebview'

// Bottom Menu
// import createBottomMenu from '@/components/BottomMenu/createBottomMenu'
import createBottomMenu from '@/components/managebot/bottommenu/create_bottommenu'
// import ListBottomMenu from '@/components/BottomMenu/ListBottomMenu'
import ListBottomMenu from '@/components/managebot/bottommenu/list_bottommenu'
import EditBottomMenu from '@/components/managebot/bottommenu/edit_bottommenu'
// import EditBottomMenu from '@/components/BottomMenu/EditBottomMenu'
// carousel image message
import aboutcarousel from '@/components/home/api/imagecarouselmessage/aboutimagecarousel'
import carouselimagemsg from '@/components/home/api/imagecarouselmessage/imagecarousel_text'
import carouselimagewebview from '@/components/home/api/imagecarouselmessage/imagecarousel_webview'
import carouselimagelink from '@/components/home/api/imagecarouselmessage/imagecarousel_link'
import carouselimageimage from '@/components/home/api/imagecarouselmessage/imagecarousel_image'
import carouselimagepostback from '@/components/home/api/imagecarouselmessage/imagecarousel_postback'
// import TestAnimation from '@/components/TestAnimation'
// TestAlbum
// import Album from '@/components/testAlbum'
import Testurl from  '@/components/testurl'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: HomePage },
    { path: '/authorization/redirect', component: authen_callbackoneid },
    { path: '/test', component: test },
    { path: '/test2', component: test2 },
    { path: '/test3', component: test3 },
    { path: '/test4', component: test4 },
    { path: '/test5', component: test5 },
    { path: '/test6', component: test6 },
    { path: '/test7/:type', component: test7 },
    { path: '/testjam', component: test7 },
    { path: '/test-inapp-webview', component: testInAppWebview },
    { path: '/code-inapp-webview', component: codeInAppWebview },
    { path: '/ocr_scantext', component: testcanvas },
    { path: '/login', component: Login },
    { path: '/contact_us', component: contactus },
    { path: '/sticker/',
      component: stickerlayout,
      children: [
        {path: '/sticker/', component: stickerhomepage},
        {path: '/sticker/homepage', component: stickerhomepage},
        {path: '/sticker/S75d07738b61a535cbfaed2419e6c0116', component: stickerwonder},
        {path: '/sticker/Sec7aea7dd55f5150b51702bdeb2fa093', component: stickerwonderHNY}
      ]
    },
    { path: '/develop/',
      component: Layout,
      children: [
        {path: '/develop/homepage', component: bothomepage},
        {path: '/develop/information_dev', component: devprofile},
        {path: '/develop/createbot', component: createbot},
        {path: '/develop/message_reply/:id/:tokenbot', component: msgreply},
        {path: '/develop/homepage/:id/:tokenbot', component: firstbot},
        {path: '/develop/bottommenu/create/:tokenbot', component: createBottomMenu},
        // {path: '/develop/bottommenu/createjam/:tokenbot', component: createBottomMenuJam},
        {path: '/develop/bottommenu/list/:tokenbot', component: ListBottomMenu},
        {path: '/develop/bottommenu/edit/:tokenbot/:bottommenu_id', component: EditBottomMenu},
        {path: '/develop/editbot/:id/:tokenbot', component: editbot},
        {path: '/develop/docs',
          component: apihomepage,
          children: [
            { path: '/develop/docs', component: homepageapibot },
            { path: '/develop/docs/authorization', component: authorization },
            { path: '/develop/docs/manage_bot/add', component: apimanagebotadd },
            { path: '/develop/docs/manage_bot/show', component: apimanagebotshow },
            { path: '/develop/docs/manage_bot/remove', component: apimanagebotremove },
            { path: '/develop/docs/manage_bot/edit_name', component: apimanageboteditname },
            { path: '/develop/docs/manage_bot/edit_status', component: apimanageboteditstatus },
            { path: '/develop/docs/manage_bot/edit_picturebot', component: apimanageboteditpicturebot },
            { path: '/develop/docs/manage_bot/edit_webhook', component: apimanageboteditwebhook },
            { path: '/develop/docs/manage_bot/edit_welcomemessage', component: apimanageboteditwelcomemessage },
            { path: '/develop/docs/reply_message/add', component: apireplymessageadd },
            { path: '/develop/docs/reply_message/edit', component: apireplymessageedit },
            { path: '/develop/docs/reply_message/remove', component: apireplymessageremove },
            { path: '/develop/docs/reply_message/show', component: apireplymessageshow },
            { path: '/develop/docs/webhook/recieve', component: apiwebhookrecieve },
            { path: '/develop/docs/webhook/aboutwebhook', component: apiaboutwebhook },
            { path: '/develop/docs/webhook/reply_message', component: apiwebhookreplymsg },
            { path: '/develop/docs/webhook/message_group_broadcast', component: messageSendBroadcast },
            { path: '/develop/docs/webhook/template_group_broadcast', component: templateSendBroadcast },
            { path: '/develop/docs/webhook/disabled_webview', component: apiwebhookdisabledwebview },
            { path: '/develop/docs/webhook/reply_file', component: apiwebhookreplyfile },
            { path: '/develop/docs/webhook/reply_sticker', component: apiwebhookreplysticker },
            { path: '/develop/docs/webhook/reply_location', component: apiwebhookreplyloc },
            { path: '/develop/docs/webhook/reply_webview', component: apiwebhookreplywebview },
            { path: '/develop/docs/webhook/reply_approve', component: apiwebhookreplyapprove },
            { path: '/develop/docs/webhook/receive_message', component: apirecievemsgwebhook },
            { path: '/develop/docs/webhook/receive_file', component: apirecievefilewebhook },
            { path: '/develop/docs/webhook/receive_location', component: apirecievelocationwebhook },
            { path: '/develop/docs/webhook/receive_sticker', component: apirecievestickerwebhook },
            { path: '/develop/docs/webhook/receive_qrcode', component: apirecieveqrcodebottommenuwebhook },
            { path: '/develop/docs/webhook/noti_addbot', component: apinotiaddbot },
            { path: '/develop/docs/webhook/noti_addgroup', component: apinotiaddgroup },
            { path: '/develop/docs/webhook/noti_leavegroup', component: apinotileavegroup },
            { path: '/develop/docs/aboutbot/getlistroom', component: apigetlistroom },
            { path: '/develop/docs/aboutbot/searchfriend', component: apisearchfriend },
            { path: '/develop/docs/template/abouttemplate', component: apiabouttemplate },
            { path: '/develop/docs/template/template_message', component: apitemplatemessage },
            { path: '/develop/docs/template/template_link', component: apitemplatelink },
            { path: '/develop/docs/template/template_webview', component: apitemplatewebview },
            { path: '/develop/docs/template/template_file', component: apitemplatefile },
            { path: '/develop/docs/quickreply/aboutquickreply', component: apiaboutquickreply },
            { path: '/develop/docs/quickreply/quickreply_text', component: apiquickreplymessage },
            { path: '/develop/docs/quickreply/quickreply_webview', component: apiquickreplywebview },
            { path: '/develop/docs/quickreply/quickreply_link', component: apiquickreplylink },
            { path: '/develop/docs/quickreply/quickreply_datepicker', component: apiquickreplydatepicker },
            { path: '/develop/docs/quickreply/quickreply_datetimepicker', component: apiquickreplydatetimepicker },
            { path: '/develop/docs/quickreply/quickreply_location', component: apiquickreplymap },
            { path: '/develop/docs/quickreply/quickreply_image', component: apiquickreplyimage },
            { path: '/develop/docs/quickreply/quickreply_file', component: apiquickreplyfile },
            { path: '/develop/docs/quickreply/quickreply_ocr', component: apiquickreplyocr },
            { path: '/develop/docs/bottommeunu/aboutbottommeunu', component: docsbottommenuabout },
            { path: '/develop/docs/bottommeunu/getprofile', component: docsbottommenugetprofile },
            { path: '/develop/docs/carouselimage/aboutimagecarousel', component: aboutcarousel },
            { path: '/develop/docs/carouselimage/carouselimage_msg', component: carouselimagemsg },
            { path: '/develop/docs/carouselimage/carouselimage_webview', component: carouselimagewebview },
            { path: '/develop/docs/carouselimage/carouselimage_link', component: carouselimagelink },
            { path: '/develop/docs/carouselimage/carouselimage_image', component: carouselimageimage },
            { path: '/develop/docs/carouselimage/carouselimage_postback', component: carouselimagepostback }
          ]
        }
      ],
      meta: { requiresAuth: true }
    },
    { path: '/register', component: Register },
    { path: '/download', component: Download },
    { path: '/download-uat-version', component: DownloadUat },
    { path: '/policy', component: Policy },
    { path: '/aboutus', component: Aboutus },
    { path: '/contactus', component: contactus },
    { path: '/docs',
      component: api,
      children: [
        { path: '/docs', component: homepageapibot },
        { path: '/docs/authorization', component: authorization },
        { path: '/docs/manage_bot/add', component: apimanagebotadd },
        { path: '/docs/manage_bot/show', component: apimanagebotshow },
        { path: '/docs/manage_bot/remove', component: apimanagebotremove },
        { path: '/docs/manage_bot/edit_name', component: apimanageboteditname },
        { path: '/docs/manage_bot/edit_status', component: apimanageboteditstatus },
        { path: '/docs/manage_bot/edit_picturebot', component: apimanageboteditpicturebot },
        { path: '/docs/manage_bot/edit_webhook', component: apimanageboteditwebhook },
        { path: '/docs/manage_bot/edit_welcomemessage', component: apimanageboteditwelcomemessage },
        { path: '/docs/reply_message/add', component: apireplymessageadd },
        { path: '/docs/reply_message/edit', component: apireplymessageedit },
        { path: '/docs/reply_message/remove', component: apireplymessageremove },
        { path: '/docs/reply_message/show', component: apireplymessageshow },
        { path: '/docs/webhook/recieve', component: apiwebhookrecieve },
        { path: '/docs/webhook/aboutwebhook', component: apiaboutwebhook },
        { path: '/docs/webhook/reply_message', component: apiwebhookreplymsg },
        { path: '/docs/webhook/reply_location', component: apiwebhookreplyloc },
        { path: '/docs/webhook/reply_file', component: apiwebhookreplyfile },
        { path: '/docs/webhook/reply_sticker', component: apiwebhookreplysticker },
        { path: '/docs/webhook/reply_webview', component: apiwebhookreplywebview },
        { path: '/docs/webhook/reply_approve', component: apiwebhookreplyapprove },
        { path: '/docs/webhook/receive_message', component: apirecievemsgwebhook },
        { path: '/docs/webhook/message_group_broadcast', component: messageSendBroadcast },
        { path: '/docs/webhook/template_group_broadcast', component: templateSendBroadcast },
        { path: '/docs/webhook/receive_file', component: apirecievefilewebhook },
        { path: '/docs/webhook/receive_location', component: apirecievelocationwebhook },
        { path: '/docs/webhook/receive_sticker', component: apirecievestickerwebhook },
        { path: '/docs/webhook/receive_qrcode', component: apirecieveqrcodebottommenuwebhook },
        { path: '/docs/webhook/noti_addbot', component: apinotiaddbot },
        { path: '/docs/webhook/noti_addgroup', component: apinotiaddgroup },
        { path: '/docs/webhook/noti_leavegroup', component: apinotileavegroup },
        { path: '/docs/aboutbot/getlistroom', component: apigetlistroom },
        { path: '/docs/aboutbot/searchfriend', component: apisearchfriend },
        { path: '/docs/template/abouttemplate', component: apiabouttemplate },
        { path: '/docs/template/template_message', component: apitemplatemessage },
        { path: '/docs/template/template_link', component: apitemplatelink },
        { path: '/docs/template/template_webview', component: apitemplatewebview },
        { path: '/docs/template/template_file', component: apitemplatefile },
        { path: '/docs/quickreply/aboutquickreply', component: apiaboutquickreply },
        { path: '/docs/quickreply/quickreply_text', component: apiquickreplymessage },
        { path: '/docs/quickreply/quickreply_webview', component: apiquickreplywebview },
        { path: '/docs/quickreply/quickreply_link', component: apiquickreplylink },
        { path: '/docs/quickreply/quickreply_datepicker', component: apiquickreplydatepicker },
        { path: '/docs/quickreply/quickreply_datetimepicker', component: apiquickreplydatetimepicker },
        { path: '/docs/quickreply/quickreply_location', component: apiquickreplymap },
        { path: '/docs/quickreply/quickreply_image', component: apiquickreplyimage },
        { path: '/docs/quickreply/quickreply_file', component: apiquickreplyfile },
        { path: '/docs/quickreply/quickreply_ocr', component: apiquickreplyocr },
        { path: '/docs/bottommeunu/aboutbottommeunu', component: docsbottommenuabout },
        { path: '/docs/bottommeunu/getprofile', component: docsbottommenugetprofile },
        { path: '/docs/others/disabled_webview', component: apiwebhookdisabledwebview },
        { path: '/docs/others/switch_keyboard', component: apiwebhookswitchkeyboard },
        { path: '/docs/carouselimage/aboutimagecarousel', component: aboutcarousel },
        { path: '/docs/carouselimage/carouselimage_msg', component: carouselimagemsg },
        { path: '/docs/carouselimage/carouselimage_webview', component: carouselimagewebview },
        { path: '/docs/carouselimage/carouselimage_link', component: carouselimagelink },
        { path: '/docs/carouselimage/carouselimage_image', component: carouselimageimage },
        { path: '/docs/carouselimage/carouselimage_postback', component: carouselimagepostback }
      ]
    },
    {
      path: '/Layouts',
      component: Layoutmo,
      children: [
        { path: '/mobile/develop/homepage', component: homepagemo },
        { path: '/mobile/develop/profile', component: devprofilemo },
        { path: '/mobile/dev_createbot', component: createbotmo },
        { path: '/mobile/dev_listbot', component: listbotmo },
        { path: '/mobile/dev_editbot/:id', component: detailbot },
        { path: '/mobile/dev_msgreply/:id', component: msgreplymo },
        { path: '/mobile/dev_manage/:id', component: managebotmo }
      ],
      meta: { requiresAuth: true }
    },
    { path: '/testurl', component: Testurl },
    { path: '*', component: notfound }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((x) => x.meta.requiresAuth)) {
    if (localStorage.getItem('status_login') !== 'T' || localStorage.getItem('status_login') === null) {
      next({ path: '/login' })
    } else {
      next()
    }
    return
  }
  next()
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((x) => x.meta.requiresLogin)) {
    if (localStorage.getItem('status_login') === 'T') {
      next({ path: '/' })
    } else {
      next({ path: '/login' })
    }
    return
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js